import {writable} from 'svelte/store';
import type {TrustpilotType} from 'types/general';
import starsImg from 'general/assets/stars.png';

const initialValue: TrustpilotType = {
    numberOfReviews: 52750,
    stars: {
        height: 18,
        width: 98,
        url: starsImg,
    },
    score: 4.5,
    starsRepresentation: 'Excellent',
};

export const trustpilotStore = writable<TrustpilotType>(initialValue);
